<template>
  <v-container fluid>
    <h2 class="mt-5 mb-6">{{$t('hierarchy')}}</h2>
    <v-card>
      <v-tabs background-color="white" color="primary" left @change="changeActiveTab($event)">
       
        <v-tab>{{$t('position')}}</v-tab>
        <v-tab>{{$t('grade')}}</v-tab>
        <v-tab>{{$t('employement_status')}}</v-tab>

        <v-tab-item>
          <v-container fluid>
            <job-position  v-if="tabActive == 0"></job-position>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <Grade  v-if="tabActive == 1"/>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <MasterEmployeeStatus  v-if="tabActive == 2"/>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
// import axios from "axios";
import JobPosition from './components/JobPosition.vue'
import MasterEmployeeStatus from './components/MasterEmployeeStatus.vue'
import Grade from './components/Grade.vue'

export default {
  name: "MasterData",
  data() {
    return {
      tabActive: 0,
    };
  },
  methods: {
    changeActiveTab(e) {
      this.tabActive = e;
    },
  },
  computed: {
    gcClaimEnabled() {
      return this.$store.getters.gcGetData('feature_claim', 'is_enabled')
    },
  },
  created() {},
  components: {
    JobPosition,
    MasterEmployeeStatus,
    Grade,
  },
};
</script>
